export const ConditionalWrapper = ({
  condition,
  wrapper,
  children,
}: {
  condition: boolean;
  wrapper: (children: any) => void;
  children: any;
}) => (condition ? wrapper(children) : children);
